<template>
  <div class="container">
    <el-tabs v-model="activeName" :before-leave="tabsChange">
      <el-tab-pane label="基础信息" name="baseInfo" v-loading="baseInfoLoading">
        <h2>工作室基础信息</h2>
        <el-form :label-position="'right'" label-width="153px">
          <el-form-item label="工作室LOGO：">
            <img class="logo" :src="baseInfo.head" />
          </el-form-item>
          <el-form-item label="工作室名称：">
            <span>{{ baseInfo.name }}</span>
            <el-button
              type="text"
              @click="$router.push({ name: 'authentication' })"
              v-show="!baseInfo.vip"
              >申请认证工作室</el-button
            >
          </el-form-item>
          <el-form-item label="工作室ID：">
            {{ baseInfo.studio_id }}
          </el-form-item>
          <el-form-item label="创建时间：">
            {{ baseInfo.apply_time | formatTime }}
          </el-form-item>
          <el-form-item label="工作室介绍：">
            {{ baseInfo.description }}
          </el-form-item>
          <el-form-item label="工作室公告：">
            {{ baseInfo.notice }}
          </el-form-item>
        </el-form>
        <h2>工作室权限</h2>
        <el-form :label-position="'right'" label-width="153px">
          <el-form-item label="加入申请：">
            {{ baseInfo.allow_join | allowJoinText }}
          </el-form-item>
          <!--判断是否已存在独立密码-->
          <div v-if="baseInfo.vip">
            <el-form-item label="登录密码：" v-if="certify_password == false">
              <span>关闭</span>
              <span class="modify-cerify" @click="changeType(1)">
                设置独立密码</span
              >
            </el-form-item>
            <el-form-item label="登录密码：" v-else>
              <span>开启</span>
              <span class="modify-cerify" @click="changeType(2)">
                修改独立密码</span
              >
              <span class="modify-cerify" @click="changeType(3)">
                关闭独立密码</span
              >
            </el-form-item>
          </div>
        </el-form>
        <el-button
          id="updateBaseInfo"
          class="largeCenterBtn"
          type="primary"
          @click="$router.push({ name: 'updateBaseInfo' })"
          >修改</el-button
        >
      </el-tab-pane>
      <el-tab-pane
        :disabled="!baseInfo.vip"
        label="认证信息"
        name="vipInfo"
        lazy
      >
        <el-form :label-position="'right'" label-width="153px">
          <el-form-item label="公司全称：">
            {{ baseInfo.company_name }}
          </el-form-item>
          <el-form-item label="营业执照注册号：">
            {{ baseInfo.company_id }}
          </el-form-item>
          <el-form-item label="营业执照信息：">
            <img class="logo" :src="baseInfo.company_image" />
          </el-form-item>
          <el-form-item label="法定代表人姓名：">
            {{ baseInfo.boss_name }}
          </el-form-item>
          <el-form-item label="法人身份证号：">
            {{ baseInfo.boss_id }}
          </el-form-item>
          <el-form-item label="法人身份证信息：">
            <img :src="baseInfo.boss_id_front" class="reatangleImg" />
            <img :src="baseInfo.boss_id_back" class="reatangleImg" />
          </el-form-item>
          <el-form-item label="银行卡号：">
            {{ baseInfo.bank_card }}
          </el-form-item>
          <el-form-item label="所属银行：">
            {{ baseInfo.bank_name }}
          </el-form-item>
          <el-form-item label="所属支行：">
            {{ baseInfo.bank_branch }}
          </el-form-item>
          <el-form-item label="银行卡正面照：">
            <img :src="baseInfo.bank_card_front" class="reatangleImg" />
          </el-form-item>
        </el-form>
        <el-button
          id="updateAuthenticationInfo"
          class="largeCenterBtn"
          type="primary"
          @click="
            $router.push({
              name: 'authentication',
              params: { requestType: 'update' },
            })
          "
          >修改</el-button
        >
      </el-tab-pane>
    </el-tabs>
    <!--设置独立密码-->
    <el-dialog
      title="设置独立密码"
      width="600px"
      class="certify-wrap"
      @close="closeDialog"
      :visible.sync="setvisible"
    >
      <div class="certify-intro">
        设置密码后，签约成员登录创作者服务平台需要验证独立密码才可登录，请谨慎设置
      </div>
      <div class="certify-content">
        <el-form
          ref=" certifyForm"
          :model="certifyForm"
          label-width="120px"
          class="certify-form"
        >
          <el-form-item label="输入密码">
            <el-input v-model="certifyForm.password" class="certify-pass">
            </el-input>
          </el-form-item>
          <el-form-item label="再次输入密码">
            <el-input v-model="certifyForm.password1" class="certify-pass">
            </el-input>
          </el-form-item>
        </el-form>
        <div class="error-message" v-if="errorMessage">{{ errorMessage }}</div>
        <div class="error-message" v-else><br /></div>
        <el-button @click="login" type="primary" class="login_btn">
          确认
        </el-button>
        <div class="certify-dialog-bottom">
          请牢记您的独立密码，暂无法通过其他方式找回
        </div>
      </div>
    </el-dialog>
    <!--修改独立密码-->
    <el-dialog
      title="修改独立密码"
      width="600px"
      class="certify-wrap"
      @close="closeDialog"
      :visible.sync="modvisible"
    >
      <div class="certify-intro">您正在进行重要操作，请先验证您的手机号</div>
      <div class="certify-content">
        <el-form
          ref=" certifyForm"
          :model="certifyForm"
          label-width="130px"
          class="certify-form"
        >
          <el-form-item label="输入新密码">
            <el-input v-model="modifyForm.password" class="certify-pass">
            </el-input>
          </el-form-item>
          <el-form-item label="输入手机验证码">
            <el-input v-model="modifyForm.code" class="certify-phone">
            </el-input>
            <span
              class="btn-get-code"
              :class="{ 'btn-forbid': isDisabled }"
              @click="getCode"
              >{{ codeTxt }}</span
            >
          </el-form-item>
        </el-form>
        <div class="error-message" v-if="errorMessage1">
          {{ errorMessage1 }}
        </div>
        <div class="error-message" v-else><br /></div>
        <el-button @click="login_mod" type="primary" class="login_btn">
          确认</el-button
        >
        <div class="certify-dialog-bottom">
          请牢记您的独立密码，暂无法通过其他方式找回
        </div>
      </div>
    </el-dialog>
    <!--关闭独立密码-->
    <el-dialog
      title="关闭独立密码"
      width="600px"
      class="certify-wrap"
      @close="closeDialog"
      :visible.sync="delvisible"
    >
      <div class="certify-intro">
        关闭独立密码后，签约成员可直接使用迷你账号及密码登录创作者服务平台
      </div>
      <div class="certify-content">
        <el-form
          ref=" certifyForm"
          :model="certifyForm"
          label-width="130px"
          class="certify-form"
        >
          <el-form-item label="输入手机验证码">
            <el-input
              v-model="deleteForm.code"
              class="certify-phone"
              placeholder="请输入验证码"
            >
            </el-input>
            <span
              class="btn-get-code"
              :class="{ 'btn-forbid': isDisabled }"
              @click="getCode"
              >{{ codeTxt }}</span
            >
          </el-form-item>
        </el-form>
        <div class="error-message" v-if="errorMessage2">
          {{ errorMessage2 }}
        </div>
        <div class="error-message" v-else><br /></div>
        <el-button @click="login_del" type="primary" class="login_btn">
          确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { getStudioDetail } from '@/api/studio';
import { judgeCertify, getVercode, modCertify, delCertify } from '@/api/common';
import { encryptPwd } from '@/utils/crypto';
import { DESCRIPTION_DEFAULT, NOTICE_DEFAULT } from '../../CONST';
export default {
  data() {
    return {
      baseInfoLoading: false,
      activeName: 'baseInfo',
      baseInfo: null,
      vipInfo: {},
      //vip:'',
      certifyState: 0,
      certify_password: false,
      errorMessage: '',
      errorMessage1: '',
      errorMessage2: '',
      certifyForm: {
        password: '',
        password1: '',
      },
      modifyForm: {
        password: '',
        code: '',
      },
      deleteForm: {
        code: '',
      },
      setvisible: false,
      modvisible: false,
      delvisible: false,
      codeTxt: '获取验证码',
      isDisabled: false,
      token2: '',
    };
  },
  computed: {
    ...mapState(['developerInfo', 'userInfo']),
  },
  filters: {
    allowJoinText(type) {
      return type ? '允许申请' : '不允许申请';
    },
    formatTime(time) {
      let t = new Date(time * 1000);
      return (
        t.getFullYear() +
        '-' +
        (101 + t.getMonth() + '').slice(-2) +
        '-' +
        (100 + t.getDate() + '').slice(-2)
      );
    },
  },
  beforeRouteEnter(to, from, next) {
    console.log('beforeRouteEnter', to, from);
    next(vm => {
      vm.activeName = vm.$route.params.activeName || 'baseInfo';
    });
  },
  async created() {
    this.baseInfoLoading = true;
    let studioBaseInfo = sessionStorage.getItem('studioBaseInfo');
    if (studioBaseInfo) {
      this.baseInfo = JSON.parse(studioBaseInfo);
    } else {
      let res = await getStudioDetail({ json: 1 });
      let { data } = res;
      this.baseInfo = data;
      sessionStorage.setItem('studioBaseInfo', JSON.stringify(data));
    }
    this.baseInfoLoading = false;
    this.baseInfo.description =
      this.baseInfo.description || DESCRIPTION_DEFAULT;
    this.baseInfo.notice = this.baseInfo.notice || NOTICE_DEFAULT;
    //this.vip=this.baseInfo.vip;
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      //let temp=sessionStorage.getItem('set')
      //工作室设置页曝光埋点
      this.$log('studio_setting_show', 85447, { v7: 1 });
      if (sessionStorage.getItem('setible')) {
        this.certify_password = true;
      }
      if (sessionStorage.getItem('token2')) {
        this.token2 = sessionStorage.getItem('token2');
      }
    },
    tabsChange(name) {
      if (
        name === 'vipInfo' &&
        this.baseInfo &&
        !this.$route.params.jumpTabsChangeCheck
      ) {
        this.$router.push({
          name: 'beforeUpdateAuthInfo',
        });
      } else {
        return true;
      }
    },
    changeType(state) {
      switch (state) {
        case 1:
          this.setvisible = true;
          break;
        case 2:
          this.modvisible = true;
          break;
        case 3:
          this.delvisible = true;
          break;
        default:
          break;
      }
    },
    closeDialog() {
      this.certifyForm.password = '';
      this.certifyForm.password1 = '';
      this.errorMessage = '';
      this.errorMessage1 = '';
      this.errorMessage2 = '';
      this.modifyForm.password = '';
      this.modifyForm.code = '';
      this.deleteForm.code = '';
    },
    login() {
      let reg1 = /^[A-Za-z0-9]{8,16}$/; //8-16位英文字母及数字组成的密码
      let reg2 = /^[A-Za-z]{8,16}$/; //8-16位英文字母组成的密码
      let reg3 = /^[0-9]{8,16}$/; //8-16位数字组成的密码
      let temp = this.certifyForm.password;
      if (temp.length < 8 || temp.length > 16)
        this.errorMessage = '请输入8-16位英文或数字或结合的密码';
      else if (!reg1.test(temp) & !reg2.test(temp) & !reg3.test(temp)) {
        this.errorMessage = '请输入英文或数字或结合的密码';
      } else if (this.certifyForm.password1 !== this.certifyForm.password) {
        this.errorMessage = '两次输入的密码不一致';
      } else {
        this.loginFn();
      }
    },
    login_mod() {
      let reg1 = /^[A-Za-z0-9]{8,16}$/; //8-16位英文字母及数字组成的密码
      let reg2 = /^[A-Za-z]{8,16}$/; //8-16位英文字母组成的密码
      let reg3 = /^[0-9]{8,16}$/; //8-16位数字组成的密码
      let temp = this.modifyForm.password;
      if (temp.length < 8 || temp.length > 16)
        this.errorMessage1 = '请输入8-16位英文或数字或结合的密码';
      else if (!reg1.test(temp) & !reg2.test(temp) & !reg3.test(temp)) {
        this.errorMessage1 = '请输入英文或数字或结合的密码';
      } else {
        this.loginModFn();
      }
    },
    login_del() {
      this.loginDelFn();
    },
    //设置独立密码
    async loginFn() {
      let data = {
        second_pwd: encryptPwd(this.certifyForm.password),
        uin: this.userInfo.uin,
      };
      let res = await judgeCertify(data);
      if (res.code === 500) {
        this.$message.success('独立密码设置成功，请重新登录');
        //修改当前状态为开启
        this.certify_password = true;
        this.setvisible = false;
      }
    },
    //修改独立密码
    async loginModFn() {
      let data = {
        second_pwd: encryptPwd(this.modifyForm.password),
        vercode: this.modifyForm.code,
        uin: this.userInfo.uin,
        token2: this.token2,
      };
      let res = await modCertify(data);
      if (res.code === 500) {
        this.$message.success('独立密码修改成功，请重新登录');
        this.modvisible = false;
      }
    },
    //关闭独立密码
    async loginDelFn() {
      let data = {
        vercode: this.deleteForm.code,
        uin: this.userInfo.uin,
        token2: this.token2,
        //second_pwd:''
      };
      let res = await delCertify(data);
      if (res.code === 0) {
        this.$message.success('独立密码已关闭');
        //修改当前状态为关闭状态
        this.certify_password = false;
        this.delvisible = false;
      }
    },
    //获取验证码
    getCode() {
      this.fetchGetVercode();
    },
    //发送验证码
    async fetchGetVercode() {
      try {
        await getVercode({
          phone: this.developerInfo.phone,
          tk: this.userInfo.tk,
        });
        this.$message.success('发送成功');
        this.countDown();
      } catch (error) {
        console.log(error);
      }
    },
    // 倒计时
    countDown() {
      let time = 59;
      const interId = setInterval(() => {
        time--;
        if (time > 0) {
          this.codeTxt = `重新发送${time}S`;
          this.isDisabled = true;
        } else {
          clearInterval(interId);
          this.isDisabled = false;
          this.codeTxt = '获取验证码';
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;
.container {
  padding: 32px 0;
  // .title-wrap{
  //   border-bottom: 1px solid #d9d9d9;
  //   .title-inner-wrap{
  //     padding: 0 32px;
  //   }
  // }
  ::v-deep .el-tabs__item {
    font-size: 20px;
    padding: 0;
    margin-right: 20px;
    line-height: 26px;
  }
  ::v-deep.el-tabs__nav-wrap::after {
    display: none;
  }
  ::v-deep.el-tabs__active-bar {
    display: none;
  }
  ::v-deep .el-tabs__header {
    margin: 0 32px;
    margin-bottom: 18px;
    border-bottom: 1px solid #d9d9d9;
  }
  ::v-deep .el-tabs__content {
    padding: 0 32px;
  }
  ::v-deep .el-form-item__label {
    color: #595959;
    font-size: 16px;
    line-height: 28px;
  }
  ::v-deep .el-form-item__content {
    color: #262626;
    font-size: 16px;
    line-height: 28px;
  }
  .el-button--text {
    color: #2b6ddf;
    padding: 0;
  }
  .el-form-item {
    // display: flex;
    // justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    margin-bottom: 16px;
  }
  ::v-deep .el-tabs__item.is-active {
    border-bottom: 4px solid #fd9b21;
    position: relative;
    color: #fd9b21;
    &:before {
      display: block;
      content: '';
      width: 0;
      border-width: 4px;
      border-style: solid;
      border-color: transparent transparent $--color-primary transparent;
      position: absolute;
      left: 50%;
      margin-left: -2px;
      bottom: 0;
    }
  }
  .modify-cerify {
    color: #2b6ddf;
    margin-left: 20px;
    cursor: pointer;
  }
  h2 {
    font-size: 24px;
    line-height: 31px;
    color: #262626;
    margin-bottom: 24px;
  }
  .logo {
    width: 70px;
    height: 70px;
    background: #d8d8d8;
    border-radius: 8px;
    border: 1px solid #f565a5;
  }
  .reatangleImg {
    width: 111px;
    height: 70px;
    background: #d8d8d8;
    border-radius: 8px;
    border: 1px solid #f565a5;
    margin-right: 24px;
  }
  .largeCenterBtn {
    display: block;
    margin: 50px auto 40px;
    width: 201px;
    height: 50px;
    background: #fd9b21;
    border-radius: 8px;
    font-size: 20px;
    &.el-button--info {
      background: #d9d9d9;
      color: #fff;
      border-color: #d9d9d9;
    }
  }
  .certify-wrap {
    border-radius: 8px;
    font-weight: 600;
    color: #262626;
    display: flex;
    max-height: 700px;
    .certify-intro {
      font-weight: 400;
      font-size: 16px;
      color: #262626;
      line-height: 28px;
    }
    .certify-content {
      font-weight: 400;
      .error-message {
        margin-top: 15px;
        margin-left: 128px;
        color: #f7424e;
        font-size: 16px;
      }
      .login_btn {
        width: 200px;
        margin-top: 88px;
        font-size: 20px;
        margin-left: 190px;
        height: 50px;
        background: #fd9b21;
        border-radius: 4px;
      }
      .certify-dialog-bottom {
        margin-top: 25px;
        margin-bottom: 24px;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        color: #bfbfbf;
        line-height: 28px;
      }
      .certify-form {
        margin-top: 32px;
        //left:0
      }
    }
  }
  .el-input {
    width: 360px;
    height: 40px;
    font-size: 16px;
    margin-left: 6px;
  }
  .certify-phone {
    width: 230px;
    margin-right: 20px;
  }
  .btn-forbid {
    cursor: not-allowed;
    background: #d9d9d9 !important;
    &:hover {
      filter: brightness(100%);
    }
  }
  .btn-get-code {
    display: inline-block;
    width: 110px;
    height: 32px;
    cursor: pointer;
    //background: $--color-primary;
    background: #fd9b21;
    border-radius: 8px;
    color: #ffffff;
    line-height: 32px;
    text-align: center;
  }
}
</style>
